<script>
export default {
  props: ['member_type'],
  data() {
    return {
      formSent: false,
      formData: {
        name: '',
        email: '',
        phone: '',
        area: '',
        idiotita: '',
        type: ''
      }
    }
  },
  mounted() {
    this.formData.type = this.member_type;
  },
  methods: {
    sendForm() {
      this.$refs["join_form"].validate().then((success) => { 
        if (success) {
          this.formSent = true;
          axios
            .post("/memberjoin/", this.formData, {
              headers: {
                "Content-Type": "application/json",
              },
            })
            .catch((e) => {
              this.formSent = false;
              console.log(e.response.data);
              if (e.response.data.errors) {
                // this.form_errors = e.response.data.errors;
              }
            });
        }
      });
    }
  }
}
</script>